import React, {useEffect, useMemo} from 'react';
import styled from "styled-components";
import ChampionHistoryContent from "./HistoryContent";
import {useDispatch, useSelector} from "react-redux";
import {GET_CHAMPIONS_PATCH_HISTORY_REQUEST} from "../../store/reducer/champions";
import {Loading} from "../common";
import InternalServerError from "../common/InternalError";
import {sortChampData} from "../../function";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 80vh;
`;

const ChampionsHistory = ({champion}) => {
    const dispatch = useDispatch();
    const {
        patchHistory,
        getChampionsPatchHistoryLoading,
        getChampionsPatchHistoryDone,
        getChampionsPatchHistoryError,
    } = useSelector((state) => state.champions);
    const currentLang = useSelector((state) => state.translation.lang);

    useEffect(() => {
        if (!getChampionsPatchHistoryLoading) {
            dispatch({
                type: GET_CHAMPIONS_PATCH_HISTORY_REQUEST,
                data: {
                    championId: champion.championId,
                    currentLang: currentLang
                }
            })
        }
    }, [currentLang]);


    const mainPatchList = useMemo(() => {
        if (patchHistory.sr_patch_history) {
            if (patchHistory?.sr_patch_history?.champion_patch_history_list) {
                const result = [...patchHistory?.sr_patch_history?.champion_patch_history_list].reverse();
                const aramList = [...patchHistory?.aram_patch_history?.champion_patch_history_list].reverse();
                const filteredAramList = aramList.filter((data) => !result.find((item) => item.version === data.version));
                const addParam = filteredAramList.map((data) => {
                    return {...data, type: 'ARAM'}
                });
                const soredArray = sortChampData([...result, ...addParam], [{sortType: false, value: 'reg_date'}])
                return soredArray;
            }

        } else {
            return [];
        }
    }, [patchHistory]);

    const aramPatchList = useMemo(() => {
        if (patchHistory.aram_patch_history) {
            const result = patchHistory?.aram_patch_history?.champion_patch_history_list;
            return result;
        } else {
            return [];
        }
    }, [patchHistory])

    if (getChampionsPatchHistoryLoading) return <Loading/>
    if (getChampionsPatchHistoryError) {
        return (
            <InternalServerError/>
        )
    }
    return (
        <Wrapper>
            {mainPatchList.map((data) => {
                const aram = aramPatchList.find((item) => item.version === data.version && data.type !== 'ARAM');
                return (
                    <ChampionHistoryContent
                        key={data.version}
                        champion={champion}
                        patchHistory={data}
                        aram={aram}
                    />
                )
            })}
        </Wrapper>
    );
};

export default ChampionsHistory;
